import { IPublicClientApplication } from "@azure/msal-browser";
import { getToken } from "Components/Functions";
import { api } from "./apiConfig"

export const VehicleAPI = {
    GetMotorhomes: async function () {
        const apiCall = await api();
        const response = await apiCall.request({
            url: "Vehicle/GetMotorhomes",
            method: "GET",
        });
        return response.data
    },
    GetVehicle: async function (instance:IPublicClientApplication, vehicleId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Vehicle/GetVehicle?vehicle_id=${vehicleId}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    },
    CheckAvailability: async function (instance:IPublicClientApplication, startDate: string, endDate: string, vehicleId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Vehicle/CheckVehicleAvailabilityWithPrice?start_date=${startDate}&end_date=${endDate}&vehicle_id=${vehicleId}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    }
}